import { useTheme } from '../context/ThemeContext';
import { Moon, Sun } from 'lucide-react';

export const ThemeSwitcher = () => {
  const { mode, toggleMode } = useTheme();

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <button
        onClick={toggleMode}
        className="p-3 rounded-full bg-surface border border-border text-text-main hover:text-primary shadow-lg transition-all hover:scale-105"
        title="Przełącz tryb Jasny/Ciemny"
      >
        {mode === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
      </button>
    </div>
  );
};
